import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/fields/$fieldId/insights")({
    component: RouteComponent,
});

function RouteComponent() {
    return <Outlet />;
}
